export default "__VITE_ASSET__31055053__"